import React from 'react';

export default function TrendingContainer() {
  return <div className="mobile:px-5 tablet-lg:px-[40px] pt-5">Trending</div>;
}
